import { useMemo } from 'react';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PlaylistAssignmentsProgressContainer from './PlaylistAssignmentsProgressContainer';
import { getTotalProgressFromItemsProgress } from '../playlistAssignmentsUtils';
import AvatarViewer from '../../avatar/components/AvatarViewer';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { MaybeRouterLink } from '../../../components/AcademyLinks';
import { getProfilePagePath } from '../../../utils/RoutingUtils';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentProgress = ({
  assignment: {
    assignee: {
      firstName,
      lastName,
      userId,
      avatarHash
    },
    portalId
  },
  userProgress
}) => {
  const displayName = formatName({
    firstName,
    lastName
  });
  const {
    itemsProgress
  } = userProgress || {
    itemsProgress: []
  };
  const progressPercentage = useMemo(() => getTotalProgressFromItemsProgress(itemsProgress), [itemsProgress]);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    gap: 24,
    children: [/*#__PURE__*/_jsx(MaybeRouterLink, {
      href: getProfilePagePath(userId, portalId),
      isRouterLink: portalId === PortalIdParser.get(),
      scrollToTop: true,
      to: `/profile/${userId}`,
      children: /*#__PURE__*/_jsx(AvatarViewer, {
        avatarHash: avatarHash,
        displayName: displayName,
        size: "md",
        type: "contact"
      })
    }), /*#__PURE__*/_jsxs(PlaylistAssignmentsProgressContainer, {
      children: [/*#__PURE__*/_jsx(MaybeRouterLink, {
        href: getProfilePagePath(userId, portalId),
        isRouterLink: portalId === PortalIdParser.get(),
        scrollToTop: true,
        to: `/profile/${userId}`,
        children: displayName
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: I18n.text('learningCenter.playlistAssignments.assignmentProgress', {
          progressPercentage: I18n.formatPercentage(progressPercentage)
        }),
        children: /*#__PURE__*/_jsx(Progress, {
          "aria-label": I18n.text('learningCenter.playlistAssignments.assignmentProgress', {
            progressPercentage: I18n.formatPercentage(progressPercentage)
          }),
          use: "success",
          value: progressPercentage
        })
      })]
    })]
  });
};
export default PlaylistAssignmentProgress;